import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { FormGroup, Input, Label, ModalBody, ModalFooter } from "reactstrap";
import { object, string } from "yup";
import ToastHandler from "../../../components/Common/ToastHandler";
import Axios from "../../../lib/Axios";

const schema = object({
  fieldOfStudyName: string().required("Required"),
});

const FOSForm = ({ data, setEditData, refetch }) => {
  const [toast, setToast] = useState(false);

  const [toastData, setToastData] = useState({
    title: "",
    message: "",
  });

  async function onSubmit(formData) {
    try {
      const dt = data
        ? {
            ...formData,
            fieldOfStudyId: data.fieldOfStudyId,
            isVerified: true,
          }
        : {
            ...formData,
            isVerified: true,
          };

      const result = data
        ? await Axios.post("/cms/cms-edit/field-of-study", dt)
        : await Axios.post("/cms/cms-set/field-of-study", dt);

      setToastData({
        message: "Submitted",
        title: "Success",
      });
      setToast(true);
      refetch();
    } catch (error) {
      if (error.status === 500) {
        setToastData({
          message: error.response.data.error.message,
          title: "Error",
        });
        setToast(true);
      } else if (error.status === 400) {
        setToastData({
          message: error.response.data.message,
          title: "Error",
        });
        setToast(true);
      }
    }
  }

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      fieldOfStudyName: data ? data?.fieldOfStudyName : "",
    },
    validationSchema: schema,
    onSubmit: onSubmit,
  });

  useEffect(() => {
    return () => {
      if (data) {
        setEditData(null);
      }
    };
  }, []);

  return (
    <>
      <form className="tablelist-form" onSubmit={formik.handleSubmit}>
        <ModalBody>
          <div className="mb-3">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom01">FoS name</Label>
              <Input
                placeholder="FoS name"
                type="text"
                className="form-control"
                id="fieldOfStudyName"
                name="fieldOfStudyName"
                value={formik.values.fieldOfStudyName}
                onChange={formik.handleChange}
              />

              {formik.touched.fieldOfStudyName &&
                formik.errors.fieldOfStudyName && (
                  <div className="error">{formik.errors.fieldOfStudyName}</div>
                )}
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            {/* <button
            type="button"
            className="btn btn-light"
            // onClick={() => setmodal_list(false)}
          >
            Close
          </button> */}
            <button
              disabled={formik.isSubmitting}
              type="submit"
              className="btn btn-success"
            >
              {formik.isSubmitting ? "Wait..." : "Submit"}
            </button>
          </div>
        </ModalFooter>
      </form>
      <ToastHandler
        open={toast}
        setOpen={setToast}
        duration={2000}
        message={toastData.message}
        title={toastData.title}
      />
    </>
  );
};

export default FOSForm;
